module.exports = __webpack_public_path__ + "img/IMG_6689_L_BlackMatted_MockedUp.c537c7e5.jpg";